import React from 'react';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';
import Header from './../../../component/common/AdminHeader';
import moment from 'moment'

// import { Typeahead } from 'react-bootstrap-typeahead';
// import 'react-bootstrap-typeahead/css/Typeahead.css';

import Loader from './../../../component/common/Loader';

import CONSTANT from './../../../constant';
import { onChange, setOptions, validateForm, validateEmail, sleep } from './../../../utils';
import { getDepartmentList, getGradeList, getGroupList, getDesignationList, getUnitList } from './../../../actions/MasterAction';
import { addUser, addUserBulk } from './../../../actions/UserAction';
const Excel = require('./../../../assets/excel/ccil-user-sample.xlsx');

class ComponentName extends React.Component<any, any>{
    constructor(props: any) {
        super(props);
        this.state = {
            department: { name: 'department', value: '', options: [], error: '', isRequired: true },
            grade: { name: 'grade', value: '', options: [], error: '', isRequired: true },
            group: { name: 'group', value: '', options: [], error: '', isRequired: true },
            designation: { name: 'designation', value: '', options: [], error: '', isRequired: true },
            unit: { name: 'unit', value: '', options: [], error: '', isRequired: true },
            uploadedFile: null,
            showLoader: false,
            rawExcel: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        document.title = CONSTANT.pageTitle.adminSection;

        getDepartmentList().then((res: any) => {
            setOptions(this, this.state.department.name, res.result);
        });

        getGradeList().then((res: any) => {
            setOptions(this, this.state.grade.name, res.result);
        });

        getGroupList().then((res: any) => {
            setOptions(this, this.state.group.name, res.result);
        });

        getDesignationList(1).then((res: any) => {
            setOptions(this, this.state.designation.name, res.result);
        });

        getUnitList().then((res: any) => {
            setOptions(this, this.state.unit.name, res.result);
        });
    }

    render() {
        const { rawExcel, department, designation, group, grade, unit } = this.state;
        const isValidExcel = this.validateExcel();
        const { showLoader } = this.state;

        return (
            <div className="container-fluid">
                <div className="row">
                    {/* <div className="col-md-2 px-0">
                        <Header />
                    </div> */}
                    <div className="col-md-12">
                        <div className='card homedob'>
                            <div className="row">
                                <div className="col-md-12 my-3">
                                    <h1 className="page-title">Upload User(s)</h1>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-12">
                                                    <div>
                                                        <form name="contact_form" className="form-transparent">
                                                            <div className="row">
                                                                <div className="col-sm-12">
                                                                    <div className="form-group">
                                                                        <label htmlFor="form_email">Excel <small>*</small></label>
                                                                        <input name="users_data" className="form-control" style={{ padding: 3.5 }} type="file" placeholder="Enter Email" onChange={this.fileOnChange} />
                                                                        <small><a className="c-pointer btn-link" href={Excel}>Click here to download a sample file</a></small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12">
                                                    <table className="table table-hover table-bordered">
                                                        <tbody>
                                                            <tr className="active">
                                                                <td className="font-weight-bold">#</td>
                                                                <td className="font-weight-bold">Status</td>
                                                                <td className="font-weight-bold">Emp #</td>
                                                                <td className="font-weight-bold">Name</td>
                                                                <td className="font-weight-bold">Email</td>
                                                                <td className="font-weight-bold">Mobile</td>
                                                                <td className="font-weight-bold">Dept</td>
                                                                <td className="font-weight-bold">Is HOD</td>
                                                                <td className="font-weight-bold">Designation</td>
                                                                <td className="font-weight-bold">Grade</td>
                                                                <td className="font-weight-bold">Unit</td>
                                                                <td className="font-weight-bold">Group</td>
                                                                <td className="font-weight-bold">DOB</td>
                                                                <td className="font-weight-bold">DOJ</td>
                                                            </tr>
                                                            {
                                                                rawExcel.length === 0 && <tr>
                                                                    <td colSpan={14} className="text-center">No records found</td>
                                                                </tr>
                                                            }
                                                            {
                                                                rawExcel.map(function (item: any, index: number) {
                                                                    const specialChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]/;
                                                                    const result = specialChars.test(item.name);
                                                                    const validName = item.name && item.name.length !== 0 && !result;
                                                                    const validMobile = item.mobile && item.mobile.length === 10;
                                                                    const validEmail = item.email && item.email.length > 0 ? validateEmail(item.email) : true;
                                                                    const validEmpNo = item.employeeNumber && item.employeeNumber.length > 0;
                                                                    const validHOD = item.isHOD === 'YES' || item.isHOD === 'NO';
                                                                    const departmentFilter = department.options.filter((i: any) => i.name === item.department);
                                                                    const validDepartment = departmentFilter.length > 0;

                                                                    const designationFilter = designation.options.filter((i: any) => i.name === item.designation);
                                                                    const validDesignation = designationFilter.length > 0;


                                                                    const gradeFilter = grade.options.filter((i: any) => i.name === item.grade);
                                                                    const validGrade = gradeFilter.length > 0;
                                                                    const unitFilter = unit.options.filter((i: any) => i.name === item.unit);
                                                                    const validUnit = unitFilter.length > 0;
                                                                    const groupFilter = group.options.filter((i: any) => i.name === item.group);
                                                                    const validGroup = groupFilter.length > 0;
                                                                    const validDOB = item.dob && item.dob.length !== 0;
                                                                    const validDOJ = item.doj && item.dob.length !== 0;

                                                                    const status = item.status;
                                                                    const statusMsg = item.statusMsg;

                                                                    return (
                                                                        <tr key={index} className={item.paymentStatus ? 'success' : ''}>
                                                                            <td>{index + 1}</td>
                                                                            <td>
                                                                                {
                                                                                    status === undefined ?
                                                                                        <i title="Click on Upload User(s) button to upload data" className="fa fa-upload" /> :
                                                                                        (status ? <i title={statusMsg} className="success fa fa-check-circle-o" /> : <i title={statusMsg} className="fa fa-exclamation-circle" />)
                                                                                }
                                                                            </td>
                                                                            <td className={validEmpNo ? '' : 'bg-danger'}>{item.employeeNumber}</td>
                                                                            <td className={validName ? '' : 'bg-danger'}>{item.name}</td>
                                                                            <td className={validEmail ? '' : 'bg-danger'}>{item.email}</td>
                                                                            <td className={validMobile ? '' : 'bg-danger'}>{item.mobile}</td>
                                                                            <td className={validDepartment ? '' : 'bg-danger'}>{item.department}</td>
                                                                            <td className={validHOD ? '' : 'bg-danger'}>{item.isHOD}</td>
                                                                            <td className={validDesignation ? '' : 'bg-danger'}>{item.designation}</td>
                                                                            <td className={validGrade ? '' : 'bg-danger'}>{item.grade}</td>
                                                                            <td className={validUnit ? '' : 'bg-danger'}>{item.unit}</td>
                                                                            <td className={validGroup ? '' : 'bg-danger'}>{item.group}</td>
                                                                            <td className={validDOB ? '' : 'bg-danger'}>{item.dob}</td>
                                                                            <td className={validDOJ ? '' : 'bg-danger'}>{item.doj}</td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-10">&nbsp;</div>
                                                <div className="col-md-2">
                                                    <button title={!isValidExcel ? 'Please upload a valid excel and try again' : ''} disabled={!isValidExcel} className="btn btn-sm submit-button pull-right" onClick={this.uploadUsers}>
                                                        Upload User(s)
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showLoader && <Loader />
                }
            </div>
        )
    }

    private fileOnChange = (e: any) => {
        e.stopPropagation();
        e.preventDefault();

        let files = e.target.files, f = files[0];
        let reader = new FileReader();
        this.setState({uploadedFile: f})

        reader.onload = (e: any) => {
            let data: any = e.target.result;
            if (!rABS) data = new Uint8Array(data);
            let workbook = XLSX.read(data, {
              type: rABS ? "binary" : "array",
              cellDates: true,
              cellNF: false,
              cellText: false,
            });

            /* DO SOMETHING WITH workbook HERE */
            let worksheet = workbook.Sheets[workbook.SheetNames[0]];
            let container = document.getElementById('tableau');
            let json = XLSX.utils.sheet_to_json(worksheet);

            for (let i = 0; i < json.length; i++) {
                const item = json[i];

                json[i].employeeNumber = item.employeeNumber && item.employeeNumber.toString();
                json[i].name = item.name && item.name.toString().trim().replace(/\r\n/g, '').replace(/[\r\n]/g, '');;
                json[i].email = item.email && item.email.toString().toLowerCase().trim();
                json[i].mobile = item.mobile && item.mobile.toString().trim();

                json[i].department = item.department && item.department.toString().trim();
                json[i].designation = item.designation && item.designation.toString().trim();
                json[i].grade = item.grade && item.grade.toString().trim();
                json[i].unit = item.unit && item.unit.toString().trim();
                json[i].group = item.group && item.group.toString().trim();
                json[i].dob = item.dob && moment(item.dob).format('YYYY-MM-DD');
                json[i].doj = item.doj && moment(item.doj).format('YYYY-MM-DD');

                json[i].status = undefined;
                json[i].statusMsg = '';
            }

            this.setState({ rawExcel: json });
            // var html = XLSX.utils.sheet_to_html(worksheet);
            // container.innerHTML = html;
        };

        let rABS = true; // true: readAsBinaryString ; false: readAsArrayBuffer
        if (rABS) reader.readAsBinaryString(f); else reader.readAsArrayBuffer(f);
    }

    private uploadUsers = async (e: any) => {
        e.preventDefault();
        if (this.validateExcel()) {
            this.setState({ showLoader: true });
            const { rawExcel, department, designation, grade, unit, group, uploadedFile } = this.state;
            let recordsProcessed = 0;

            addUserBulk(rawExcel).then(() => {
                this.setState({ showLoader: false });
            })

            // for await (const data of rawExcel) {
            //     try {
            //         await sleep(1);

            //         const item = data;
            //         const departmentFilter = department.options.filter((i: any) => i.name === item.department);
            //         const designationFilter = designation.options.filter((i: any) => i.name === item.designation);
            //         const gradeFilter = grade.options.filter((i: any) => i.name === item.grade);
            //         const unitFilter = unit.options.filter((i: any) => i.name === item.unit);
            //         const groupFilter = group.options.filter((i: any) => i.name === item.group);

            //         const model = {
            //             employeeNumber: item.employeeNumber,
            //             name: item.name,
            //             email: item.email,
            //             mobile: item.mobile,

            //             isHOD: item.isHOD === 'YES',
            //             designationCode: designationFilter[0].code,
            //             gradeCode: gradeFilter[0].code,
            //             departmentCode: departmentFilter[0].code,
            //             unitCode: unitFilter[0].code,
            //             groupCode: groupFilter[0].code,
            //             dob: item.dob,
            //             doj: item.doj
            //         };

            //         addUser(model).then((res: any) => {
            //             ++recordsProcessed;
            //             if (recordsProcessed === rawExcel.length) {
            //                 this.setState({ showLoader: false });
            //             }

            //             if (res.status === 'success') {
            //                 const rawExcel = this.state.rawExcel.map((item: any) => {
            //                     if (item.employeeNumber === model.employeeNumber) {
            //                         item.status = true;
            //                         item.statusMsg = "Uploaded successfully";
            //                     }
            //                     return item;
            //                 });
            //                 this.setState({ rawExcel })
            //             } else {
            //                 const rawExcel = this.state.rawExcel.map((item: any) => {
            //                     if (item.employeeNumber === model.employeeNumber) {
            //                         item.status = false;
            //                         item.statusMsg = res.error.message;
            //                     }
            //                     return item;
            //                 });
            //                 this.setState({ rawExcel })
            //             }
            //         });

            //     } catch (error) {
            //         alert(error.message);
            //     }
            // }
        } else {
            alert('Please fix the issues highlighted in red color.');
        }
    }


    private validateExcel = () => {
        const { rawExcel, department, designation, grade, unit, group, dob, doj } = this.state;
        const specialChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]/;
        let status = true;
        for (let i = 0; i < rawExcel.length; i++) {
            const item = rawExcel[i];

            const result = specialChars.test(item.name);
            const validName = item.name && item.name.length !== 0 && !result;
            if (!validName) {
                status = false;
                break;
            }
            const validMobile = item.mobile && item.mobile.length === 10;
            if (!validMobile) {
                status = false;
                break;
            }
            const validEmail = item.email && validateEmail(item.email);
            if (item.email && !validEmail) {
                status = false;
                break;
            }
            const validEmpNo = item.employeeNumber && item.employeeNumber.length > 0;
            if (!validEmpNo) {
                status = false;
                break;
            }
            const validHOD = item.isHOD === 'YES' || item.isHOD === 'NO';
            if (!validHOD) {
                status = false;
                break;
            }
            const departmentFilter = department.options.filter((i: any) => i.name === item.department);
            const validDepartment = departmentFilter.length > 0;
            if (!validDepartment) {
                status = false;
                break;
            }

            const designationFilter = designation.options.filter((i: any) => i.name === item.designation);
            const validDesignation = designationFilter.length > 0;
            if (!validDesignation) {
                status = false;
                break;
            }

            const gradeFilter = grade.options.filter((i: any) => i.name === item.grade);
            const validGrade = gradeFilter.length > 0;
            if (!validGrade) {
                status = false;
                break;
            }

            const unitFilter = unit.options.filter((i: any) => i.name === item.unit);
            const validUnit = unitFilter.length > 0;
            if (!validUnit) {
                status = false;
                break;
            }

            const groupFilter = group.options.filter((i: any) => i.name === item.group);
            const validGroup = groupFilter.length > 0;
            if (!validGroup) {
                status = false;
                break;
            }
        }
        if (rawExcel.length === 0) {
            status = false;
        }
        return status;
    }
}

export default ComponentName;